module.exports = __webpack_public_path__ + "712afc150ef3b2cea24fd09457fe4247.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/12_B2.mp3
// module id = 111
// module chunks = 0